import { render, staticRenderFns } from "./GraphDetail08.vue?vue&type=template&id=1da20078&scoped=true&"
import script from "./GraphDetail08.vue?vue&type=script&lang=js&"
export * from "./GraphDetail08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da20078",
  null
  
)

export default component.exports